<template>
    <div>
        <app-kpiform v-if="kpi"
        v-bind:parentObject="{
            kpi: this.kpi,
            pmkpiexercisestatus: this.pmkpiexercisestatus,
            basekpi: this.basekpi,
            list: this.list,
            roleName: this.roleName,
            staffData: this.staffData
        }"
        />
    </div>
</template>

<script>

import KPIForm from '../../sscomponents/performance/MyStaffProgressForm.vue';

export default {

    components: {
        'app-kpiform': KPIForm,
    },

    data() {
        return {
            kpi: this.$route.params.kpi,
            pmkpiexercisestatus: this.$route.params.pmkpiexercisestatus,
            basekpi: this.$route.params.basekpi, //origin kpi that is being viewed, used for back navigation
            list: this.$route.params.list,
            roleName: this.$route.params.roleName,
            staffData: this.$route.params.staffData
        }

        
    },

    methods: {
    },

    mounted() {
        console.log("KPIProgress:", this.kpi);
    }
}

</script>

<style scoped>

</style>